import React, { useState } from 'react';
import { CloseIcon, SearchIcon } from '../../utils/icons';
import colors from '../../utils/colors';

const DescriptionIcon = () => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="w-6 h-6"
  >
    <path
      d="M10 18.9631C10.8333 18.9631 11.5417 18.6715 12.125 18.0881C12.7083 17.5048 13 16.7965 13 15.9631V8.96313H15C15.5523 8.96313 16 8.51542 16 7.96313C16 7.41085 15.5523 6.96313 15 6.96313H12.5C11.9477 6.96313 11.5 7.41085 11.5 7.96313V13.3631C11.2667 13.2298 11.025 13.1298 10.775 13.0631C10.525 12.9965 10.2667 12.9631 10 12.9631C9.16667 12.9631 8.45833 13.2548 7.875 13.8381C7.29167 14.4215 7 15.1298 7 15.9631C7 16.7965 7.29167 17.5048 7.875 18.0881C8.45833 18.6715 9.16667 18.9631 10 18.9631ZM12 22.9631C10.6167 22.9631 9.31667 22.7006 8.1 22.1756C6.88333 21.6506 5.825 20.9381 4.925 20.0381C4.025 19.1381 3.3125 18.0798 2.7875 16.8631C2.2625 15.6465 2 14.3465 2 12.9631C2 11.5798 2.2625 10.2798 2.7875 9.06313C3.3125 7.84647 4.025 6.78813 4.925 5.88813C5.825 4.98813 6.88333 4.27563 8.1 3.75063C9.31667 3.22563 10.6167 2.96313 12 2.96313C13.3833 2.96313 14.6833 3.22563 15.9 3.75063C17.1167 4.27563 18.175 4.98813 19.075 5.88813C19.975 6.78813 20.6875 7.84647 21.2125 9.06313C21.7375 10.2798 22 11.5798 22 12.9631C22 14.3465 21.7375 15.6465 21.2125 16.8631C20.6875 18.0798 19.975 19.1381 19.075 20.0381C18.175 20.9381 17.1167 21.6506 15.9 22.1756C14.6833 22.7006 13.3833 22.9631 12 22.9631ZM12 20.9631C14.2333 20.9631 16.125 20.1881 17.675 18.6381C19.225 17.0881 20 15.1965 20 12.9631C20 10.7298 19.225 8.83814 17.675 7.28814C16.125 5.73813 14.2333 4.96313 12 4.96313C9.76667 4.96313 7.875 5.73813 6.325 7.28814C4.775 8.83814 4 10.7298 4 12.9631C4 15.1965 4.775 17.0881 6.325 18.6381C7.875 20.1881 9.76667 20.9631 12 20.9631Z"
      fill={colors.text.inactive}
    />
  </svg>
);

const SavedDescriptionsModal = ({ savedDescriptions, onSelect, onClose }) => {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredDescriptions = savedDescriptions.filter(item => 
    item.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.genres.some(genre => genre.toLowerCase().includes(searchTerm.toLowerCase()))
  ).reverse();

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="w-[450px] flex flex-col rounded-3xl bg-[#252020] overflow-hidden pb-6">
        <div className="flex justify-between items-center p-6">
          <div className="w-10 h-10 opacity-0"></div>
          <h2 className="text-lg font-semibold" style={{ color: colors.text.primary }}>
            Saved Song Descriptions
          </h2>
          <button 
            onClick={onClose} 
            className="flex justify-center items-center w-10 h-10 rounded-full bg-[#363030] hover:bg-opacity-80 transition-colors"
          >
            <CloseIcon />
          </button>
        </div>
        
        <div className="px-6 flex flex-col gap-4">
          <div className="flex-grow h-10 relative rounded-full border border-white/15 overflow-hidden flex items-center px-4 gap-3">
            <SearchIcon />
            <input
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="Search"
              className="w-full bg-transparent text-base font-medium focus:outline-none"
              style={{ 
                fontFamily: 'PP Neue Montreal',
                fontWeight: 500,
                color: colors.text.primary,
                caretColor: colors.accent
              }}
            />
          </div>
          
          <div className="max-h-[400px] overflow-y-auto flex flex-col">
            {filteredDescriptions.map((item, index) => (
              <div 
                key={index} 
                onClick={() => onSelect(item)} 
                className="flex items-start gap-4 py-4 cursor-pointer hover:bg-white/5 transition-colors"
              >
                <DescriptionIcon />
                <div className="flex flex-col gap-1">
                  <p className="text-base font-medium" style={{ color: colors.text.primary }}>
                    {item.title}
                  </p>
                  <p className="text-xs" style={{ color: colors.text.tertiary }}>
                    {new Date(item.timestamp).toLocaleDateString()}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SavedDescriptionsModal;